import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { toasterMsg } from '../Components/Toaster/Toaster';

export const fetchDamHistoryList = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM_HISTORY.GET_DAM_HISTORY_LIST}`, { params });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
  }
};
